/* eslint-disable import/prefer-default-export */

import { nFormatter } from '@utils/textHelper';

export const getModifiedAttempCount = (count = 0) => {
  if (count <= 975) {
    if (count <= 50) {
      return '50+';
    }

    const num = Math.ceil(count / 25) * 25;
    return `${num}+`;
  }

  if (count < 1000) {
    return '1K+';
  }

  return `${nFormatter(count, 1)}+`;
};
